import React, { useState, useEffect } from 'react';
import { TOAST_OPTIONS } from '../../constants';

//UTILS
import Select from 'react-select';
import UserService from "../../services/user_services";
import { ToastContainer, toast } from 'react-toastify';

//COMPONENTS 
import Menu from '../../components/menu';
import BoardHeader from '../../components/boardheader';
import Button from '../../components/button';
import FollowUp from '../../components/followup';
import { transferERC20 } from '../../services/magic';
import { ThreeDots } from 'react-loader-spinner';

//VISUALS
import LOGO_BLACK from '../../assets/images/logo_black.png';
import BANKINGWEB3 from '../../assets/images/digital_banking.png';

//TRANSLATION
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

const Transfers = ({ magic }) => {
    const { t } = useTranslation();
    const [amount, setAmount] = useState("");
    const [beneficiary, setBeneficiary] = useState(null);
    const [balance, setBalance] = useState("-");
    const [loading, onChangeLoading] = useState(null);
    const [beneficiaries, setBeneficiaries] = useState([]);

    const loadBeneficiaries = async () => {
        const data = await UserService.getBeneficiaries()
        setBeneficiaries(data)
    }

    const loadInfo = async () => {
        const acc = await UserService.getAccountDetails()
        let tokens = {}
        for (let token of acc.wallet.tokens) {
            tokens[token.metadata.symbol] = token
        }
        setBalance(tokens["CaaEURO"].balance)
    }

    const transfer = async () => {
        if (!beneficiary)
            toast.error(t('transfer.invalid_address'), TOAST_OPTIONS);
        else if (!amount || amount < 1 || amount === "-" || amount > balance)
            toast.error(t('transfer.invalid_amount'), TOAST_OPTIONS);
        else {
            onChangeLoading(true);
            try {
                const receipt = await transferERC20(magic, amount * (10 ** 6), beneficiary.public_address);
                toast.success(`${t('transfer.funds_sent')} ${receipt.transactionHash.substring(0, 10)}...${receipt.transactionHash.substring(receipt.transactionHash.length - 10, receipt.transactionHash.length - 1)}`, TOAST_OPTIONS);
                setAmount("")
                setBeneficiary(null)
                onChangeLoading(false);
                setTimeout(() => {
                    loadInfo()
                }, 2500);
            } catch (e) {
                console.log(e);
                toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS);
                onChangeLoading(false);
            }
        }
    }

    useEffect(() => {
        loadInfo();
        loadBeneficiaries();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="dashboard">
            <Menu />
            <div className="right_board">
                <BoardHeader title={t('transfer.transfer_funds')} />
                <div className="content">
                    <div className="transfer_layout">
                        <div className="transfer_summary_card">
                            <span className="transfer_summary_label">CaaEURO</span>
                            <div className="transfer_summary_value_line">
                                <span className="balance">{balance}</span>
                                <img src={LOGO_BLACK} className="currency" alt="Logo CâaEuro" />
                            </div>
                            <span className="transfer_summary_hint">{t('transfer.set_amount')}</span>
                        </div>

                        <div className="transfer_form_card">
                            <label className="transfer_label">{t('transfer.select_beneficiary')}</label>
                            {beneficiaries && <div className="select transfer_select_wrap">
                                <Select
                                    className="transfer_select"
                                    classNamePrefix="transfer_select"
                                    placeholder={t('transfer.select_beneficiary')}
                                    options={beneficiaries}
                                    value={beneficiary}
                                    onChange={(value) => setBeneficiary(value)}
                                    formatOptionLabel={beneficiary => (beneficiary.user_uuid ?
                                        <div className="select_profile">
                                            <div className="select_avatar" style={{ backgroundImage: beneficiary.selfie ? `url('data:image/${beneficiary.selfie_ext};base64,${beneficiary.selfie}')` : `url('https://api.dicebear.com/9.x/pixel-art-neutral/svg?seed=${beneficiary.user_uuid}.png')` }}></div>
                                            <div className="select_info">
                                                <span className="select_name">{beneficiary.firstname} {beneficiary.lastname}</span>
                                                <span className="select_email">{beneficiary.email_address}</span>
                                            </div>
                                        </div>
                                        :
                                        <div className="select_profile">
                                            <div className="select_avatar" style={{ backgroundImage: `url('https://api.dicebear.com/9.x/pixel-art-neutral/svg?seed=${beneficiary.public_address}.png')` }}></div>
                                            <div className="select_info">
                                                <span className="select_name">{beneficiary.email || t('transfer.external_account')}</span>
                                                <span className="select_email">{beneficiary.public_address.substring(0, 10)}...{beneficiary.public_address.substring(0, 15)}</span>
                                            </div>
                                        </div>
                                    )}
                                />
                            </div>}
                            <div className="transfer_followup_row">
                                <FollowUp intro={t('transfer.cant_find')} description={t('transfer.add_beneficiary')} link={"/beneficiaries"} />
                            </div>

                            <label className="transfer_label">{t('transfer.set_amount')}</label>
                            <div className="relative transfer_amount_wrap">
                                <input type="number" className="semi" placeholder={t('transfer.caaeuro_amount')} onChange={(e) => setAmount(e.target.value)} value={amount} />
                                <span className="transfer_max_badge">Max {balance} <img src={LOGO_BLACK} width={"10px"} alt="Logo CâaEuro" /></span>
                            </div>

                            {!loading &&
                                <div className="transfer_form_actions">
                                    <Button title={t('transfer.send_funds')} click={transfer} />
                                    <FollowUp intro={t('transfer.no_fees')} />
                                </div>
                            }
                        </div>
                    </div>
                    <div className="transfer_loader">
                        <ThreeDots visible={loading} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                    </div>
                </div>
                {!isMobile && <img src={BANKINGWEB3} className="visual v_mobile" alt="Digital banking" />}
            </div>
            <ToastContainer />
        </div>
    )
};

export default Transfers;